<template>
    <NuxtLayout class="project-client-root">
        <NuxtPage :transition="transitionProps" />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {usePageSlideTransition} from '@malt/utils';

    const transitionProps = usePageSlideTransition({
        pathsOrder: ['/', '/project'],
    });
</script>

<style lang="scss">
    html {
        background-color: var(--joy-color-neutral-10);
        min-height: 100%;
    }

    body {
        font-size: var(--joy-font-size-primary-400);
        font-family: var(--joy-font-family-base);
    }

    div.project-list-root {
        h1 {
            font-family: var(--joy-font-family-title) !important;
            font-style: normal !important;
            font-weight: var(--joy-font-weight-normal) !important;
            font-size: var(--joy-font-size-l) !important;
            line-height: var(--joy-line-height-small) !important;
            color: var(--joy-color-neutral-60);
        }
    }
</style>
